import { Checkbox, Skeleton, tableHelpers } from '@round/creatorbase-ui';
import { CellContext } from 'Modules/Plans/CreatorSearch/components/CreatorExploreTable/helpers';
import { HeaderContext, getTableMeta } from '../../helpers';
import styles from './SelectCreatorCell.module.css';

export const SelectCreatorCell = ({ row: { original }, table }: CellContext) => {
    const { isLoading, selectedCreatorIds, onCreatorToggle } = getTableMeta(table);

    if (tableHelpers.isLoadingRow(original) || isLoading) {
        return <Skeleton className={styles.skeleton} />;
    }

    return (
        <Checkbox
            checked={selectedCreatorIds.has(original._id)}
            onCheckedChange={() => onCreatorToggle(original._id)}
            aria-label="Select creator"
        />
    );
};

export const SelectAllCreatorsHeader = ({ table }: HeaderContext) => {
    const { selectedCreatorIds, onSelectAll, onClearSelection } = getTableMeta(table);

    // Loading rows carry no creator id, so they never count towards the selection.
    const selectableCreatorIds = table
        .getRowModel()
        .rows.map(({ original }) => (tableHelpers.isLoadingRow(original) ? undefined : original._id))
        .filter((creatorId): creatorId is string => typeof creatorId === 'string');

    const areAllSelected =
        selectableCreatorIds.length > 0 && selectableCreatorIds.every((creatorId) => selectedCreatorIds.has(creatorId));
    const areSomeSelected = selectableCreatorIds.some((creatorId) => selectedCreatorIds.has(creatorId));

    return (
        <Checkbox
            checked={areAllSelected}
            indeterminate={!areAllSelected && areSomeSelected}
            onCheckedChange={() => (areAllSelected ? onClearSelection() : onSelectAll(selectableCreatorIds))}
            disabled={!selectableCreatorIds.length}
            aria-label="Select all creators"
        />
    );
};
